export default "__VITE_ASSET__Dh3bEjpQ__"